const PAGES = [
  "/contact-us",
  "/about-us",
  "/support",
  "/news",
  "/announcements",
  "/earn-referral",
  "/earn",
  "/coin-info",
  "/zmt",
  "/campaigns",
  "/glossary",
  "/zlaunch",
];

const TRADE_COIN_PAGES = {
  btc: "bitcoin",
  eth: "ethereum",
};

const getWpContexts = (lang) =>
  ({
    en: {
      wpLocale: "en_US",
      wpGlobalConfig: ".com",
      wpShareGlobalConfig: ".all",
    },
    au: {
      wpLocale: "en_US",
      wpGlobalConfig: ".com.au",
      wpShareGlobalConfig: ".all",
    },
    th: {
      wpLocale: "th",
      wpGlobalConfig: ".co.th",
      wpShareGlobalConfig: ".co.th",
    },
    th_en: {
      wpLocale: "en_US",
      wpGlobalConfig: ".co.th",
      wpShareGlobalConfig: ".all",
    },
    id: {
      wpLocale: "id_ID",
      wpGlobalConfig: ".co.id",
      wpShareGlobalConfig: ".co.id",
    },
    id_en: {
      wpLocale: "en_US",
      wpGlobalConfig: ".co.id",
      wpShareGlobalConfig: ".all",
    },
  }[lang]);

const getPageContexts = (page, lang) => {
  let inCategories;
  switch (lang) {
    case "en":
      inCategories = ["articles-en"];
      break;
    case "au":
      inCategories = ["articles-en"];
      break;
    case "th":
      inCategories = ["articles-th", "podcasts"];
      break;
    case "th_en":
      inCategories = ["articles-en"];
      break;
    case "id":
      inCategories = ["articles-id"];
      break;
    case "id_en":
      inCategories = ["articles-en"];
      break;
  }

  const isGlobal = lang === "en";
  const isThai = lang === "th" || lang === "th_en";
  const isIndo = lang === "id" || lang === "id_en";

  return {
    "": {
      isGlobal,
      isIndo,
    },
    "contact-us": {
      isIndo,
    },
    learn: {
      isThai,
      inCategories,
    },
    "earn-referral": {
      isIndo,
    },
    earn: {
      isGlobal,
      isThai,
      isIndo,
    },
    ziplock: {
      isGlobal,
      isThai,
      isIndo,
    },
  }[page.split("/")[1] || ""];
};

const getTradeContexts = (action, coin) => ({
  heroSection: `${action}-${coin}`,
  howToSection: `how-${action}-${coin}-zipmex`,
  howToStepsSection: `how-${action}-${coin}-zipmex-steps`,
  imageTradeExchange: `images/buy-exchange-${
    coin === "bitcoin" ? "btc" : "eth"
  }.svg`,
  aboutCoinSection: `about-coin-${coin}`,
  otherCoinSection: `other-${action}-coins`,
  tradeCoinSection: `${action}-${coin}`,
  whyUseZipmexSection: `why-use-zipmex-${action}-${coin}`,
  hereToHelpSection: `${action}-here-to-help-${coin}`,
  ctaInvestSection: `cta-${action}-invest-anywhere-anytime`,
});

const ARTICLE_ID = {
  en_US: 1804,
  id_ID: 2391,
  th: 1190,
};

const PODCAST_ID = {
  th: 1749,
};

const CAMPAIGN_DATE_TIME_FORMAT = "MMM D, YYYY h:mm a";

//NOTE: Affects the sequence of sorting campaigns items.
// 1st: live
// 2nd: coming soon
// 3rd: ended
const CAMPAIGN_STATUS = {
  LIVE: "live",
  COMING_SOON: "coming soon",
  ENDED: "ended",
};

module.exports = {
  PAGES,
  TRADE_COIN_PAGES,
  getWpContexts,
  getPageContexts,
  getTradeContexts,
  ARTICLE_ID,
  PODCAST_ID,
  CAMPAIGN_DATE_TIME_FORMAT,
  CAMPAIGN_STATUS,
};
